module.exports = __webpack_public_path__ + "static/Banking_products-3cd5272df18e059921a57cab8a48c15a.jpg";